import type { ComponentDocMap } from './types'

/**
 * Prop documentation for the `abs_labs` anchor component.
 */
export const absLabsPropDocs: ComponentDocMap = {
  children: {
    description: 'Child UI configs rendered in separate cards.',
    type: 'ReactNode[]',
  },
}
